import RecruiterCandidateSendSubmissionRound from './RecruiterCandidateSendSubmissionRound';
import { SendCaseStudyToUserInput } from 'types';

const RecruiterCandidateSendCaseStudy = (props: {
	userId?: string;
	userName?: string;
	positionId?: string;
	isLoading?: boolean;
	onSubmit?: (data: SendCaseStudyToUserInput) => void;
	onFinish?: () => void;
}) => <RecruiterCandidateSendSubmissionRound variant="caseStudy" {...props} />;

export default RecruiterCandidateSendCaseStudy;
